import * as Config from 'modules/utils/ConfigUtils';

export const LOCAL_STORAGE_TOKEN = 'DFD_AUTH';

export const MHP_AUTH_CONFIG = {
  tokenEndpoint: `${Config.AUTH_SERVER_BASE_URL}${Config.AUTH_END_POINT_TOKEN}`,
  client_id: Config.AUTH_CLIENT_ID,
  clientSecret: Config.AUTH_SECRET,
  grant_type: 'authorization_code',
  redirect_uri: Config.AUTH_REDIRECT_URL,
  scope: (Config.AUTH_SCOPE || []).join(' ')
};
